import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  RadioGroupProps,
  FormLabel,
  Typography
} from '@mui/material';
import _ from 'lodash';
import { appFormUtil } from 'modules/common';
import React from 'react';

export type StyledRadioButtonFieldProps<T extends object> = {
  form: appFormUtil.InferReturn<T>;
  fieldName: keyof T;
  trueLabel?: string;
  falseLabel?: string;
  label?: string;
  includeFormLabel?: boolean;
};

export const FC = <T extends object>(props: StyledRadioButtonFieldProps<T> & RadioGroupProps) => {



  return (
    <FormControl>
      {props.includeFormLabel && (
        <FormLabel>
          <Typography
            variant='formLabel'
          >
            {props.label ?? 'LABEL'}
          </Typography>
        </FormLabel>
      )}
      <RadioGroup
        {...props}
        row={true}
        value={_.toString(props.form.formState[props.fieldName])}
        onChange={(e) => {
          const newValue = e.target.value;
          if (typeof props.form.formState[props.fieldName] === 'boolean') {
            const tempValue = e.target.value === 'true' ? true : false;
            return props.form.dispatch({
              type: 'UPDATE',
              payload: {
                property: props.fieldName,
                value: tempValue as T[keyof T]
              }
            });
          }

          props.form.dispatch({
            type: 'UPDATE',
            payload: {
              property: props.fieldName,
              value: newValue as T[keyof T]
            }
          });


        }}
      >

        <FormControlLabel
          control={<Radio />}
          value='true'
          label={props.trueLabel ?? 'True'}
        />
        <FormControlLabel
          control={<Radio />}
          value='false'
          label={props.falseLabel ?? 'False'}
        />
      </RadioGroup>
    </FormControl>
  );
};
